import classes from 'classnames';
import React, { memo, PropsWithChildren } from 'react';
import styles from './Card.module.scss';

export type Intent = 'warning' | 'success' | 'none' | 'info';

export type CardProps = {
  className?: string;
  intent?: Intent;
};

export default memo(function Card({
  className,
  children,
  intent = 'none',
}: PropsWithChildren<CardProps>) {
  return (
    <div
      className={classes(
        styles.container,
        styles[`intent-${intent}`],
        className,
      )}
    >
      {children}
    </div>
  );
});
